import { useEffect } from 'react';

import { RoutalLoader } from '@nx-smartmonkey/ui';
import { Modal } from '../../../../../../components/Modal';

interface StopAutoCompleteProps {
  onEnter?: () => void;
  isLoading?: boolean;
}

export const StopAutoComplete = ({ isLoading, onEnter }: StopAutoCompleteProps) => {
  useEffect(() => {
    onEnter && onEnter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (isLoading) {
    return (
      <Modal open={isLoading}>
        <RoutalLoader />
      </Modal>
    );
  }
  return null;
};
